export default __webpack_public_path__ + "b8ac97cb71b2b1155030308f429047ae.svg";